/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import ResetPasswordKeyCheck from './components/ResetPasswordKeyCheck'


const AuthLayout = () => {
  useEffect(() => {
    document.body.style.backgroundImage = 'none'
    return () => {}
  }, [])

  return (
    <div
      style={{
        height: '100vh'
      }}
    >
      <Outlet />
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='home/*' element={<Navigate to='/login' />} />
      <Route path='new-project/*' element={<Navigate to='/login' />} />
      <Route path='crafted/*' element={<Navigate to='/login' />} />
      {/* crafted */}
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<ResetPasswordKeyCheck />} />
      <Route path='reset-password/:rpKey' element={<ResetPasswordKeyCheck />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

// const Checker = () => {
//   useEffect(() => {})
//   return <></>
// }

export {AuthPage}
